import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const DataExport: React.FC = () => {
  return (
    <PageTemplate
      title="Data Export"
      description="Export Salesforce data to various formats"
    />
  );
};